module.exports = __webpack_public_path__ + "img/kontakt-headquarter-styria.f7dcc611.jpg";